
import { Component, Prop, Vue } from "vue-property-decorator";
import { FindIdentityProviderByIdResponse } from "@flosum-auth/contracts";
import AppInformationCard from "@/modules/shared/components/AppInformationCard.vue";
import AppInformationCardItem from "@/modules/shared/components/AppInformationCardItem.vue";
import AppSsoButton from "@/modules/shared/components/AppSsoButton.vue";

@Component({
  components: {
    AppInformationCard,
    AppInformationCardItem,
    AppSsoButton,
  },
})
export default class IdentityProvidersButtonInformationCard extends Vue {
  @Prop()
  public readonly data!: FindIdentityProviderByIdResponse;

  public get isLoading(): boolean {
    return !this.data;
  }

  public getValue<K extends keyof FindIdentityProviderByIdResponse>(key: K): FindIdentityProviderByIdResponse[K] {
    return this.data && (this.data[key] as FindIdentityProviderByIdResponse[K]);
  }
}
